@if (invite) {
  <button mat-icon-button (click)="showInvite()">
    @if (withShake) {
      <mat-icon color="accent">cake</mat-icon>
    } @else {
      <mat-icon>cake</mat-icon>
    }
  </button>
}
